import React from 'react'
import { Layout, Menu, Breadcrumb, Card } from 'antd';
// import { UserOutlined, LaptopOutlined, NotificationOutlined } from '@ant-design/icons';
import SideBar, {routes} from './sidebar'

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

const { SubMenu } = Menu;
const { Header, Content, Footer, Sider } = Layout;


export default function Admin() {
  const onFinish = values => {
    console.log("Received values of form: ", values);
  };

    return(
      <Router>
        <Layout>
    <Header className="header">
      <div className="logo" />
      <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['2']}>
 

          <SubMenu className="ml-auto" style={{ float: 'right' }}
            title={
              <span className="submenu-title-wrapper">
                jon doe
              </span>
            }
          >
            <Menu.ItemGroup title="Settings">
              <Menu.Item key="setting:3">Log Out</Menu.Item>
            </Menu.ItemGroup>
          </SubMenu>
      </Menu>
    </Header>
    <Layout>

          <SideBar/>
          
         <Layout style={{ padding: '0 24px 24px' }}>
       
        <Content
          className="site-layout-background"
          style={{
            padding: 24,
            margin: 0,
            minHeight: 280,
          }}
        >
          <Switch>
            {routes.map((route, index) => (
              // Render more <Route>s with the same paths as
              // above, but different components this time.
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                children={<route.main />}
              />
            ))}
          </Switch>

         
        </Content>
      </Layout>
    </Layout>
  </Layout>
      </Router>
    )
}